import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Stack,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
  Input,
  Checkbox  
} from '@mui/material';
import { Add, Visibility, Delete, Search } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { format } from 'date-fns';
import ApiService from '../../API/Requesthandler'
import MessagesDialog from './MessageViewDialog';
import MyMessagesDialog from './MessageViewDialog';

const ScrapingTasks = () => {
  const theme = useTheme();
  const [tasks, setTasks] = useState([]);
  const [selectedTaskMessages, setSelectedTaskMessages] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [messagesOpen, setMessagesOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [step, setStep] = useState(1);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [targetGroups, setTargetGroups] = useState([]);
  const [forwardGroups, setForwardGroups] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
    const [senderNumbers,setSenderNumbers] = useState([]);
  const [contacts,setContacts] = useState([]);
const [filteredMessages,setFilteredMessages] = useState([]);

    
    const getSessions = ()=>{
        ApiService.post("/api/phone/sessions",{"user_id":JSON.parse(localStorage.getItem("user-data"))['id']})
        .then(response =>{
        const formattedSessions = response.map((session)=>({
            id: session.id,
            phone_number:session.phone,
            status: "active",
            lastActive: new Date().toISOString(),
            user_id:session.user_id,
            session:session.session,
            default: session.default,
            username : session.username
        }));
        setSenderNumbers(formattedSessions);
        }).catch(err =>{
        console.log(err)
        })
    }

      const getChatsData = async(sender) => {
        await ApiService.get("/api/chat/get/"+JSON.parse(localStorage.getItem('user-data'))['id'] + "/" + sender)
        
          .then(res => {
            if (res.success == true) {
            //   localStorage.setItem("chats", JSON.stringify(res.data));
              setContacts(res.data);
              
            }
          }).catch(err => {
            console.log(err);
          });
      };


    const getScrapeData = async() =>{
        await ApiService.post('/api/scraper/get',{user_id: JSON.parse(localStorage.getItem('user-data'))['id']})
        .then(
            res =>{
                if (res.success){
                    
                    setTasks(res.data.reverse());}
            }
        ).then(res =>{
            console.log(res)
        })
    }

    useEffect(()=>{
        getScrapeData()
        getSessions()
        
    },[])
  const initialTaskState = {
    start_date: '',
    end_date: '',
    keyword: '',
    target_group: '',
    forward_to_group: [],
    limit: '',
    sender: '',
    user_id:''
  };

  const [newTask, setNewTask] = useState(initialTaskState);

  useEffect(() => {
    const mockTasks = [
      {
        id: 1,
        start_date: '2024-03-01',
        end_date: '2024-03-05',
        keyword: 'tech,ai',
        found: 45,
        status: 'running',
        target_group: 'Group A',
        session: 'sess_001',
        forward_to_group: 'Group B',
        sender: 'User1'
      }
    ];
    
  }, []);

  const fetchGroups = async (sender) => {
    // Simulate API call
    setLoadingGroups(true);
    await getChatsData(sender)
    
    // Mock response based on sender
    
    
    setTargetGroups(contacts);
    setForwardGroups(contacts);

    setLoadingGroups(false);
  };


  const onDelete = (task)=>{
    setTasks(tasks.filter(t => t.id !== task.id))
    ApiService.post('/api/scraper/delete',{
        "user_id":JSON.parse(localStorage.getItem('user-data'))['id'],
        "row_id":task.id
    }).then(res=>{
        if (res.success){}
    }).catch(err=>{
        console.log("error : "+err)
    })
  }

  const handleSubmitTask = async() => {
    const newTaskWithId = { ...newTask, id: tasks.length + 1 };
    setTasks([...tasks, newTaskWithId]);
    setDialogOpen(false);
    setNewTask(initialTaskState);
    newTask.user_id = JSON.parse(localStorage.getItem('user-data'))['id']
    await ApiService.post('/api/scraper/add',newTask )
    .then(res =>{
        if (res.success){
            getScrapeData()
        }
    }).then(err =>{
        console.log(err)
    })

    
    
    setStep(1);
  };

  function pythonToJson(str) {
    // Convert Python syntax to JSON
    return JSON.parse(str
        .replace(/'/g, '"')          // Replace single quotes with double quotes
        .replace(/False/g, 'false')   // Convert Python's False to JSON's false
        .replace(/True/g, 'true')     // Convert Python's True to JSON's true
    );
}


  const handleNextStep = async () => {
    if (step === 1 && newTask.sender) {
      await fetchGroups(newTask.sender);
      setStep(2);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, p: 3, backgroundColor: theme.palette.background.default }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'center' }}>
        <Typography variant="h5" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
          Scraping Tasks
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setDialogOpen(true)}
          sx={{ borderRadius: '8px', textTransform: 'none', px: 3, py: 1 }}
        >
          Create New Task
        </Button>
      </Box>

      <Paper sx={{ overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
             
                <TableCell>Keywords</TableCell>
                <TableCell>Found</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Target Group</TableCell>
                <TableCell>Session</TableCell>
                <TableCell>Forward Group</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((task) => (
                <TableRow key={task.id}>
                  
                  <TableCell>{task.keyword || ''}</TableCell>
                  <TableCell>{task.found || 0}</TableCell>
                  <TableCell>
                    <Chip
                      label={task.status || 'pending'}
                      color={task.status === 'completed' ? 'success' : 'warning'}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{task.target_group}</TableCell>
                  <TableCell>{task.sender_phone}</TableCell>
                  <TableCell>{task.forward_group}</TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <Tooltip title="Delete">
                        <IconButton onClick={()=>{onDelete(task)}}>
                          <Delete color="error" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Messages">
                        <IconButton
                          onClick={() => {
                            
                            setFilteredMessages(eval(task.result).reverse())
                            setMessagesOpen(true);
                          }}
                        >
                          {/* <Visibility color="info" /> */}
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Add Task Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => { setDialogOpen(false); setStep(1); }}
        PaperProps={{ sx: { borderRadius: '16px', minWidth: '500px' } }}
      >
        <DialogTitle sx={{ fontSize: '1.5rem', borderBottom: `1px solid ${theme.palette.divider}`, py: 2 }}>
          New Scraping Task
        </DialogTitle>
        <DialogContent sx={{mt:2,p:4,px:3 }}>
          {step === 1 && (
            <FormControl fullWidth>
              <InputLabel >Select Number</InputLabel>
              <Select
                value={newTask.sender}
                onChange={(e) => setNewTask({ ...newTask, sender: e.target.value })}
                label="Select Sender"
              >
                {senderNumbers.map(user => (
                  <MenuItem key={user.id} value={user.phone_number}>{user.phone_number}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {step === 2 && (
            <Stack spacing={3}>
              {/* <TextField
                fullWidth
                type="date"
                label="Start Date"
                InputLabelProps={{ shrink: true }}
                value={newTask.start_date}
                onChange={(e) => setNewTask({ ...newTask, start_date: e.target.value })}
              />
              <TextField
                fullWidth
                type="date"
                label="End Date"
                InputLabelProps={{ shrink: true }}
                value={newTask.end_date}
                onChange={(e) => setNewTask({ ...newTask, end_date: e.target.value })}
              /> */}
              <TextField
                fullWidth
                label="Keywords"
                value={newTask.keyword}
                onChange={(e) => setNewTask({ ...newTask, keyword: e.target.value })}
              />
              <FormControl fullWidth>
                <InputLabel>Target Group</InputLabel>
                <Select
                  value={newTask.target_group}
                  onChange={(e) => setNewTask({ ...newTask, target_group: e.target.value })}
                >
                  {contacts.map(group => (
                    <MenuItem key={group.id} value={group.id}>{group.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
              <InputLabel>Forward Group</InputLabel>
              <Select
                multiple
                value={newTask.forward_to_group}
                onChange={(e) => setNewTask({ ...newTask, forward_to_group: e.target.value })}
                renderValue={(selected) => selected.join(', ')} // Optional: Custom display
                inputProps={{
                  id: 'group-select',
                  labelId: 'group-select-label',
                }}
              >
                {contacts.map(group => (
                  <MenuItem key={group.id} value={group.id}>
                    <Checkbox checked={newTask.forward_to_group.indexOf(group.id) > -1} />
                    <ListItemText primary={group.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              {/* <FormControl fullWidth>
                
                <TextField
                fullWidth
                label="Limit"
                type='number'
                placeholder='100'
                  value={newTask.limit}
                  onChange={(e) => setNewTask({ ...newTask, limit: e.target.value })}
                />
                  
                
              </FormControl> */}
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
          <Button onClick={() => setDialogOpen(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          {step === 1 && (
            <Button
              onClick={handleNextStep}
              variant="contained"
              disabled={!newTask.sender || loadingGroups}
              sx={{ textTransform: 'none', borderRadius: '8px', px: 3 }}
            >
              {loadingGroups ? <CircularProgress size={24} /> : 'Next'}
            </Button>
          )}
          {step === 2 && (
            <Button
              onClick={handleSubmitTask}
              variant="contained"
              sx={{ textTransform: 'none', borderRadius: '8px', px: 3 }}
            >
              Create Task
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Messages Dialog */}
      <MyMessagesDialog messagesOpen={messagesOpen} setMessagesOpen={setMessagesOpen} messages={filteredMessages}/>
    </Box>
  );
};

export default ScrapingTasks;